import { Button, ConfigProvider } from "antd";
import { OperatingLayout } from "../../../layouts/operating/OperatingLayout";
import {
  IconGolf,
  IconUsersGroup,
  IconView360Arrow
} from "@tabler/icons-react";
import { Link } from "react-router-dom";

export const OperatingTools = () => {
  interface ToolButtonProps {
    toolInner: { label: string; icon: any; path?: string };
  }
  const ToolButton = ({ toolInner }: ToolButtonProps) => {
    return (
      <Link to={toolInner.path}>
        <Button
          className="h-32 w-32 flex-col text-wrap no-underline"
          type="primary"
          variant="solid"
        >
          <toolInner.icon size={30} stroke={1.5} />

          {toolInner.label}
        </Button>
      </Link>
    );
  };

  return (
    <ConfigProvider theme={{ token: { colorPrimary: "rgb(44, 21, 97)" } }}>
      <OperatingLayout pageHeader="Operating Tools">
        <div className="flex flex-row space-x-7">
          <ToolButton
            toolInner={{
              label: "AAR",
              icon: IconUsersGroup,
              path: "/roadmap/operating_tools/aar"
            }}
          />
          <ToolButton
            toolInner={{
              label: "QBR",
              icon: IconView360Arrow,
              path: "/roadmap/operating_tools/qbr_scoring"
            }}
          />
          <ToolButton
            toolInner={{
              label: "Objective Setting",
              icon: IconGolf,
              path: "/roadmap/operating_tools/objective_setting"
            }}
          />
        </div>
      </OperatingLayout>
    </ConfigProvider>
  );
};
